<template>
  <ConfirmDialog></ConfirmDialog>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Cajas</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Gestión de Gastos</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Subcategorías</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Subcategorías de Gastos
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="Nuevo"
          v-if="'Subservicio Crear' in auth.user.permissions"
          class="p-button-info p-button-lg"
          icon="pi pi-plus"
          v-tooltip.top="'Nueva Subcategoría de Gastos'"
          @click="nuevoSubServicio"
        >
        </Button>
      </div>
    </div>
    <div class="mt-2">
      <DataTable
        ref="dt_servicios"
        dataKey="id"
        :value="subservicios"
        :paginator="true"
        :loading="cargando"
        :rows="50"
        :filters="buscar"
        :rowHover="true"
        class="p-datatable-sm"
        stripedRows
        showGridlines
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[50, 100, 200]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Subcategorías"
        responsiveLayout="scroll"
        selectionMode="single click"
        @row-select="editarSubServicio($event.data)"
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar Subcategoría"
              />
            </span>
          </div>
        </template>
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >

        <Column field="id" header="CÓD." :sortable="true"></Column>
        <Column field="servicio" header="CATEGORÍA" style="font-weight: bold">
          <template #body="{ data }">
            {{ data.servicio.descripcion }}
          </template>
        </Column>
        <Column
          field="descripcion"
          header="SUBCATEGORÍA"
          style="font-weight: bold"
        ></Column>
        <Column field="created_at" header="F. CREACIÓN">
          <template #body="{ data }">
            {{ new Date(data.created_at).toLocaleDateString() }}
          </template>
        </Column>
        <Column field="updated_at" header="F. ACTUALIZACIÓN">
          <template #body="{ data }">
            {{ new Date(data.updated_at).toLocaleDateString() }}
          </template>
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado]">
              {{ data.estado == 0 ? "ANULADO" : "ACTIVO" }}
            </span>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
      <SubServicioCreate
        :show="subServicioEditarDialog"
        :subservicio="{ ...subServicio }"
        @closeModal="cerrarModalSubServicio"
        @actualizarListado="cargarSubServicios"
      />
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import SubServicioCreate from "@/module/subservicios/SubServicioCreate.vue";
import SubServicioService from "@/service/SubServicioService";

import { useAuth } from "@/stores";
export default {
  components: {
    SubServicioCreate,
  },

  data() {
    return {
      cargando: true,
      subservicios: null,
      subServicioEditarDialog: false,
      nuevoSubServicioDialog: false,
      subServicio: {},
      totalRegistros: 0,
      claseEstado: ["status-outofstock", "status-instock"],
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
    };
  },
  subServicioService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.subServicioService = new SubServicioService();
  },
  mounted() {
    this.cargarSubServicios();
  },
  methods: {
    acciones(datos) {
      return [
        {
          label: "Editar SubServicio",
          disabled:
            "Subservicio Editar" in this.auth.user.permissions ? false : true,
          icon: "pi pi-fw pi-pencil",
          command: () => {
            this.editarSubServicio(datos);
          },
        },
        {
          label: "Eliminar",
          disabled:
            "Subservicio Eliminar" in this.auth.user.permissions ? false : true,
          icon: "pi pi-fw pi-trash",
          command: () => {
            this.eliminarSubServicio(datos.id);
          },
        },
      ];
    },
    nuevoSubServicio() {
      this.subServicioEditarDialog = true;
      this.subServicio = {
        estado: { label: "ACTIVO", value: 1 },
        servicio: {
          id: null,
          descripcion: null,
        },
      };
    },
    eliminarSubServicio(id) {
      this.$confirm.require({
        message: "¿Está seguro que desea eliminar el Servicio?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, deseo eliminar",
        rejectLabel: "No, cancelar",
        accept: () => {
          this.subServicioService.eliminarSubServicio(id).then((response) => {
            if (response.status == 200) {
              this.$toast.add({
                severity: "success",
                summary: "Éxito",
                detail: response.mensaje,
                life: 3000,
              });
              this.cargarSubServicios();
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.mensaje,
                life: 3000,
              });
            }
          });
        },
      });
    },
    cargarSubServicios() {
      this.subServicioService.getSubServiciosAll().then((data) => {
        this.totalRegistros = data.total || 0;
        this.subservicios = data.subservicios || [];
        this.cargando = false;
      });
    },
    editarSubServicio(subservicio) {
      this.subServicio = { ...subservicio };
      this.subServicio.estado = {
        label: subservicio.estado == 1 ? "ACTIVO" : "INACTIVO",
        value: subservicio.estado,
      };
      this.subServicioEditarDialog = true;
    },
    cerrarModalSubServicio() {
      this.subServicioEditarDialog = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
